import { useState, useEffect, useRef } from 'react';
import { API_BASE_URL } from '../utils/apiConfig';

const POLL_INTERVAL = 60_000; // 60s — signal refreshes every 60s on backend

export function useSignal() {
  const [signal, setSignal] = useState(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchSignal() {
      try {
        const res = await fetch(`${API_BASE_URL}/api/stats?hours=1`, {
          signal: AbortSignal.timeout(10000),
        });
        if (!res.ok) return;
        const data = await res.json();
        if (!cancelled && data.success && data.signal) {
          setSignal(data.signal);
        }
      } catch {
        // silently ignore
      }
    }

    fetchSignal();
    intervalRef.current = setInterval(fetchSignal, POLL_INTERVAL);

    return () => {
      cancelled = true;
      clearInterval(intervalRef.current);
    };
  }, []);

  return signal;
}
